import { z } from "zod";

export const SearchSchema = z.object({
  operationPackageId: z.string().optional(),
  operationPackagePatternId: z.string().optional(),
});
